import { useState, useEffect } from 'react';
import { api } from '../lib/api';

export interface SEOSettings {
  id?: string;
  page_key: string;
  title: string;
  description: string;
  keywords: string;
  og_image?: string;
  canonical_url?: string;
  updated_at?: string;
}

export function useSupabaseSEO(pageKey: string) {
  const [seoData, setSeoData] = useState<SEOSettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  // Fetch SEO settings for a specific page
  const fetchSEO = async () => {
    try {
      setLoading(true);
      const data = await api.get(`/seo/${pageKey}`);
      setSeoData(data || null);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch SEO settings');
    } finally {
      setLoading(false);
    }
  };

  // Update SEO settings
  const updateSEO = async (settings: Omit<SEOSettings, 'id' | 'updated_at'>) => {
    try {
      await api.post('/seo', { ...settings, page_key: pageKey });

      await fetchSEO();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to update SEO settings');
      throw err;
    }
  };

  useEffect(() => {
    fetchSEO();
  }, [pageKey]);

  return {
    seoData,
    loading,
    error,
    fetchSEO,
    updateSEO
  };
}
